var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF6B35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9847 14.4L30.5607 15.856C30.742 15.8987 30.8913 15.9947 31.0087 16.144C31.126 16.2933 31.1847 16.4587 31.1847 16.64V24.624C31.1847 25.4347 30.9953 26.192 30.6167 26.896C30.238 27.6 29.7127 28.176 29.0407 28.624L23.9847 32L18.9287 28.624C18.2567 28.176 17.7313 27.6 17.3527 26.896C16.974 26.192 16.7847 25.4347 16.7847 24.624V16.64C16.7847 16.4587 16.8433 16.2933 16.9607 16.144C17.078 15.9947 17.2273 15.8987 17.4087 15.856L23.9847 14.4ZM23.9847 16.032L18.3847 17.28V24.624C18.3847 25.168 18.51 25.6747 18.7607 26.144C19.0113 26.6133 19.3607 26.9973 19.8087 27.296L23.9847 30.08L28.1607 27.296C28.6087 26.9973 28.958 26.6133 29.2087 26.144C29.4593 25.6747 29.5847 25.168 29.5847 24.624V17.28L23.9847 16.032ZM27.5527 20.176L28.6727 21.312L23.5847 26.4L20.1927 23.008L21.3287 21.872L23.5847 24.144L27.5527 20.176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay3);
export default __webpack_public_path__ + "static/media/Overlay-3.962da0e2b7afbd3ccb149d77881bc52b.svg";
export { ForwardRef as ReactComponent };